module.exports = __webpack_public_path__ + "assets/sentiment_negative_grey.16ad4e58.svg";